import { REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
import { useState } from "react";
import { Party } from "src/pages/Parties";
import { AlcDrawer, DrawerTitle } from "../ui/drawer";
import { InputOTPDisabled, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";

export default function InvitePartyDrawer({
  children,
  party,
}: {
  party: Party;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AlcDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={children}
      asChild
      header={
        <>
          <DrawerTitle className="text-center">Pozvánka do kalby</DrawerTitle>
        </>
      }
    >
      <div className="text-center flex items-center flex-col">
        <div className="pb-2">
          Nasdílej tento kód s ostatními, aby se mohli připojit do kalby:
        </div>
        <InputOTPDisabled
          maxLength={6}
          pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
          inputMode="text"
          value={party.code.toUpperCase()}
          className="opacity-100"
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTPDisabled>
      </div>
    </AlcDrawer>
  );
}
